<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t("add") }} {{ $tc("user", 1) }}</div>
      <router-link class="btn-blue" to="/user-management/users"
        >{{ $tc("user", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>

    <div class="white-wrapper">
      <form class="mx-auto">
        <div class="col-lg-9 col-xl-6 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="users.name"
                name="firstname"
                id="firstname"
                v-validate="'required|alpha_spaces'"
              />
              <label>{{ $t("name") }}</label>
            </div>
            <!-- <Tooltip :title="$t('user_NameTooltip')" /> -->
          </div>
          <p class="error_message">
            <span v-if="errors.has('firstname')">{{
              errors.first("firstname")
            }}</span>
          </p>
        </div>

        <div class="col-lg-9 col-xl-6 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="users.email"
                name="mail"
                id="mail"
                v-validate="'required|email'"
              />
              <label>Email</label>
            </div>
            <!-- <Tooltip :title="$t('user_NameTooltip')" /> -->
          </div>
          <p class="error_message">
            <span v-if="errors.has('mail')">{{ errors.first("mail") }}</span>
          </p>
        </div>

        <div class="col-lg-9 col-xl-6 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material row">
              <div class="col-4">
                <b-dropdown
                  :text="
                    users.dialingCode
                      ? users.dialingCode
                      : org_code
                      ? 971
                      : 'Code'
                  "
                  variant="dropdown-curve"
                  class="w-100 text-center mr-3"
                  placeholder="code"
                  name="countrycode"
                  id="countrycode"
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Code"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchCode($event.target.value)"
                      v-on:keydown="onSearchCode($event.target.value)"
                      v-on:search="onSearchCode($event.target.value)"
                      v-model="searchCode"
                    />
                  </div>
                  <b-dropdown-item
                    href="#"
                    v-for="(countrycode, countryIndex) in countryList"
                    :key="countryIndex"
                    v-on:click="onSelectHandler(countrycode)"
                    v-if="countrycode.country_mob_code != null"
                    >{{ countrycode.country_mob_code }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <div class="col-8 pl-1">
                <input
                  placeholder="."
                  v-model="users.mobile"
                  type="text"
                  name="mobileno"
                  id="monileno"
                  v-validate="'required|numeric|min:8|max:14'"
                />
                <label>{{ $t("mobiles") }}</label>
              </div>
            </div>

            <!-- <Tooltip :title="$t('user_mobile')" /> -->
          </div>
          <p class="error_message">
            <span>{{ " " }}</span>
            <span v-if="errors.has('mobileno')">{{
              errors.first("mobileno")
            }}</span>
          </p>
        </div>
        <!-- v-if="this.flag.isDistributor === false" -->

        <div class="col-lg-9 col-xl-6 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="users.role ? 'shift-up' : ''">Role</label>
              <multiselect
                :options="userRoles"
                v-model="users.role"
              ></multiselect>
            </div>
            <!-- <Tooltip :title="$t('user_NameTooltip')" /> -->
          </div>
        </div>
        <div class="d-flex col-lg-9 col-xl-6 mb-2">
          <b-form-checkbox
            class="j-checkbox"
            v-model="users.isActive"
            unchecked-value="N"
            value="Y"
          />
          <label class="mb-0">User Active</label>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            @click.prevent.stop="onFinalSubmit('update')"
            class="btn-blue"
            v-if="$route.params.userid"
          >
            {{ $t("save") }}
          </button>
          <button
            v-else
            @click.prevent.stop="onFinalSubmit('add')"
            class="btn-blue"
          >
            Add User
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import UserService from "@/services/UserService";
  import moment from "moment";
  import DatePicker from "vue2-datepicker";

  export default {
    components: { DatePicker },
    data() {
      return {
        countryList: [],
        searchCode: "",
        userRoles: ["Admin", "Viewer"],
        SelectedCountryCode: "",
        users: {
          name: "",
          role: "Admin",
          mobile: "",
          isActive: "Y",
          dialingCode: "",
        },
      };
    },
    beforeMount: async function() {
      this.users.dialingCode = this.$store.getters.getOrganizationDetails.org_contact_no_code;
      this.org_code = this.$store.getters.getOrganizationDetails.org_contact_no_code;
      let obj = this.secureStore.get("USINFO");
      console.log(this.$store.getters.getOrganizationDetails, "Test store");
      const { role_id, cinema_id } = this.secureStore.get("USINFO");
      const { userid } = this.$route.params;
      await this.getCountriesList();
      if (userid) {
        await this.getUserData(userid);
      }
    },
    mounted() {
      const { userid } = this.$route.params;
      //   this.getUserData(userid);
    },
    methods: {
      onSearchCode() {
        // this.country_mob_code == '966'
        if (this.searchCode && this.searchCode.length > 0) {
          this.countryList = this.CodeListCopy.filter((x) => {
            if (
              x.country_mob_code &&
              x.country_mob_code
                .toLowerCase()
                .includes(this.searchCode.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.countryList = this.CodeListCopy;
        }
      },
      onSelectHandler(value) {
        this.users.dialingCode = value.country_mob_code;
        this.SelectedCountryCode = value.country_mob_code;
      },
      getCountriesList: async function() {
        this.Countries = [];
        let payload = {
          tableName: "ms_countries",
          country_is_active: "Y",
        };

        const response = await MasterService.GetActiveList(payload);
        const { data } = response;
        if (data.status) {
          this.Countries = data.Records;
          this.CodeListCopy = data.Records;
          this.countryList = data.Records;
        } else {
          console.log("countries error", data.message);
        }
      },
      getUserData: async function(user_id) {
        let loader = this.$loading.show();
        let payload = { user_id };
        const response = await UserService.accessReportAppUser(payload);
        const { data } = response;
        if (data.status) {
          this.users = { ...data.data };
          this.users.role = data.data.role
            ? data.data.role.charAt(0).toUpperCase() + data.data.role.slice(1)
            : "";
        }
        loader.hide();
        this.$toasted.show(data.message);
      },
      updateUserData() {
        const { userid } = this.$route.params;
        console.log(this.$route.params);

        let loader = this.$loading.show();
        let userData = { ...this.users };
        userData.role = userData.role.toLowerCase();
        userData.dialingCode = `+${userData.dialingCode}`;
        // let payload = { user_id: userid, ...this.users };
        let payload = { user_id: userid, ...userData };
        UserService.updateReportAppUser(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.$router.push("/user-management/app-report-users");
            }
            this.$toasted.show(data.message);
            loader.hide();
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
      addUserData() {
        let loader = this.$loading.show();
        let userData = { ...this.users };
        console.log(userData);
        userData.role = userData.role.toLowerCase();
        userData.dialingCode = `+${userData.dialingCode}`;
        let payload = { ...userData };
        UserService.addReportAppUser(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.$router.push("/user-management/app-report-users");
            }
            this.$toasted.show(data.message);
            loader.hide();
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
      onFinalSubmit(type = "") {
        if (type && type === "update") {
          this.updateUserData();
        } else if (type && type === "add") {
          this.addUserData();
        }
      },
    },
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/UserManagement/ReportAppUsers/addEditReportAppUser.vue